module.exports = new __parcel__URL__("questionmark.638412b5.glb").toString();